import { useDropzone } from "react-dropzone";
import UploadImageModal from "../../../../images/uploadImage.svg";

export const ProviderDropzone = ({ onDrop, message, index }) => {
  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (acceptedFiles) => onDrop(acceptedFiles, index)
  });
  return (
    <div className="file-dropzone-component">
      <div {...getRootProps({ name: `dropzone-input-${index}` })}>
        <img src={UploadImageModal} alt="upload" />
        <input
          name={`dropzone-input-${index}`}
          {...getInputProps()}
        />
        <p>{message}</p>
      </div>
    </div>
  );
};